define('app/models/travel_search_plane_model',['app/setup'], function(takhfifan) {
  takhfifan.travelSearchPlaneModel = Backbone.Model.extend({
    defaults: {
      "adult": 1,
      "child": 0,
      "infant": 0,
      "passengersCount": 1,
      'is2Way': false
    },

    validation: {
      'origin': {
        required: true,
        msg: i18n.t('origin_missing')
      },
      'destination': {
        required: true,
        msg: i18n.t('destination_missing')
      },
      'departDate': {
        required: true,
        msg: i18n.t('depart_date_missing')
      },
      'returnDate': 'validateReturnDate',
      'passengersCount': 'validateCount'
    },

    validateReturnDate: function (value, attr, computedState){
      var returnDate = computedState.returnDate || this.get('returnDate'),
          is2Way = computedState.is2Way || this.get('is2Way');

      if(is2Way && !returnDate){
        return i18n.t('return_date_missing');
      }
    },

    validateCount:function(value, attr, computedState){
      var adult = parseInt(computedState.adult,10) || parseInt(this.get('adult')),
          child = parseInt(computedState.child,10) || parseInt(this.get('child')),
          infant = parseInt(computedState.infant,10) || parseInt(this.get('infant'));

      if(this.passengersCount() === 0) {
        return i18n.t('number_of_passengers_missing');
      }

      if(this.passengersCount() > 9){
        return i18n.t('number_of_passengers_exceed');
      }

      if(adult < infant){
        return i18n.t('number_of_adults_should_bigger_than_babies');
      }

      if(adult === 0){
        return i18n.t('at_least_one_adult');
      }
    },

    passengersCount: function () {
      return parseInt(this.get('adult'),10) + parseInt(this.get('child'),10) + parseInt(this.get('infant'),10);
    }
  });
});



